// Global Instructions Rule Applied!

import { KanbanColumn, KanbanItem, ColumnData } from '../../interfaces'

/**
 * Sort columns by sequence (null sequences go to the end)
 */
function sortColumnsBySequence<T extends KanbanItem>(columns: KanbanColumn[]): KanbanColumn[] {
  return [...columns].sort((a, b) => {
    const seqA = a.sequence ?? Number.MAX_SAFE_INTEGER
    const seqB = b.sequence ?? Number.MAX_SAFE_INTEGER
    return seqA - seqB
  })
}

/**
 * Group items into columns based on column ID field
 */
export function groupItemsIntoColumns<T extends KanbanItem>(
  columns: KanbanColumn[],
  items: T[],
  getColumnId: (item: T) => string
): ColumnData<T>[] {
  const sortedColumns = sortColumnsBySequence(columns)

  return sortedColumns.map((column) => {
    const columnItems = items.filter((item) => getColumnId(item) === column.id)

    return {
      column,
      items: columnItems
    }
  })
}

/**
 * Sort items within a column by priority
 */
export function sortItemsByPriority<T extends KanbanItem>(
  items: T[],
  getPriority: (item: T) => number | null | undefined
): T[] {
  return [...items].sort((a, b) => {
    const priorityA = getPriority(a) ?? Number.MAX_SAFE_INTEGER
    const priorityB = getPriority(b) ?? Number.MAX_SAFE_INTEGER
    return priorityA - priorityB
  })
}

/**
 * Filter visible columns
 */
export function filterVisibleColumns<T extends KanbanColumn>(columns: T[]): T[] {
  return columns.filter((column) => column.visible !== false)
}
